import { Injectable } from '@angular/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './business-users.actions';
import { BusinessUser } from '@models/businesses';

@Injectable({
	providedIn: 'root',
})
export class BusinessUsersDispatch {
	@Dispatch()
	SetSignature = (siganture: string): actions.SetSignature =>
		new actions.SetSignature(siganture);

	@Dispatch()
	SetAccessPin = (accessPin: string): actions.SetAccessPin =>
		new actions.SetAccessPin(accessPin);

	@Dispatch()
	SetLenderConsent = (lenderConsent: boolean): actions.SetLenderConsent =>
		new actions.SetLenderConsent(lenderConsent);

	@Dispatch()
	DisconnectCloserSync = (): actions.DisconnectCloserSync =>
		new actions.DisconnectCloserSync();

	@Dispatch()
	SetAssystDisconnected = (
		isAssystDisconnected: boolean,
	): actions.SetAssystDisconnected =>
		new actions.SetAssystDisconnected(isAssystDisconnected);

	@Dispatch()
	SetSyncInviteReceived = (
		syncInviteReceived: boolean,
		user: BusinessUser,
	): actions.SetSyncInviteReceived =>
		new actions.SetSyncInviteReceived(syncInviteReceived, user);

	@Dispatch()
	SetAssociatedOfficeId = (
		associatedOfficeId: string | null,
		user: BusinessUser,
	): actions.SetAssociatedOfficeId =>
		new actions.SetAssociatedOfficeId(associatedOfficeId, user);

	@Dispatch()
	SetActiveBusiness = (
		businessId: string,
		businessName: string,
	): actions.SetActiveBusiness =>
		new actions.SetActiveBusiness(businessId, businessName);
}
